import StorySource from '../../data/story-source';

export default class PostModel {
  async getStoryDetail(id) {
    const response = await StorySource.getStoryDetail(id);
    if (!response.error) {
      return response.story;
    }
    throw new Error(response.message || 'Failed to get story');
  }
}
